import React from "react";
import { Container, Row, Col } from "shards-react";
import Vehicles from "../components/contracts/ContractsVehicles";

const ContractVehiclesTable = () => (
  <Container fluid className="main-content-container px-4">
	  <Row>
      <Col className="p-2">
		    <Vehicles /> 
      </Col>
    </Row>
   </Container>
);

export default ContractVehiclesTable;
